import ReactDOM from 'react-dom';
import App from './app';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { initializeMonitoring } from './monitoring/sentry';

initializeMonitoring();

// Call the element loader before the render call
defineCustomElements(window);

const queryClient = new QueryClient();

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
  document.getElementById('root') as HTMLElement
);
